/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-28 21:33:13
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-17 19:13:38
 */
// 读取iconfont
// let a = document.getElementsByClassName('icon-code-show')
// let list = []
// for (let i = 0; i < a.length; i++) {
//   if (a[i].innerText.includes('icontubiaoku'))
//     list.push(a[i].innerText)
// }
// console.log(list)

export const iconList = [
  "icontubiaoku-1",
  "icontubiaoku-2",
  "icontubiaoku-3",
  "icontubiaoku-8",
  "icontubiaoku-9",
  "icontubiaoku-5",
  "icontubiaoku-6",
  "icontubiaoku-11",
  "icontubiaoku-4",
  "icontubiaoku-10",
  "icontubiaoku-12",
  "icontubiaoku-16",
  "icontubiaoku-15",
  "icontubiaoku-17",
  "icontubiaoku-19",
  "icontubiaoku-20",
  "icontubiaoku-22",
  "icontubiaoku-23",
  "icontubiaoku-7",
  "icontubiaoku-21",
  "icontubiaoku-24",
  "icontubiaoku-18",
  "icontubiaoku-13",
  "icontubiaoku-14",
  "icona-03jiaoseguanli",
  "icontubiaoku-25"
]
// 0106更换一批菜单图标
export const iconMapping = (icon) => {
  const mapping = {
  "icontubiaoku-1":  "icona-01gailan",
  "icona-03jiaoseguanli": "icontubiaoku-41",
  "icontubiaoku-2": "icona-02shangpin",
  "icontubiaoku-3": "icona-03gouwuche",
  "icontubiaoku-8": "icontubiaoku-81",
  "icontubiaoku-9": "icontubiaoku-91",
  "icontubiaoku-5": "icontubiaoku-51",
  "icontubiaoku-6": "icona-06shuju",
  "icontubiaoku-11": "icontubiaoku-111",
  "icontubiaoku-4": "icona-04kehu",
  "icontubiaoku-10": "icona-10wenjianjia",
  "icontubiaoku-12": "icona-12liuliang",
  "icontubiaoku-16": "icontubiaoku-161",
  "icontubiaoku-15": "icontubiaoku-151",
  "icontubiaoku-17": "icontubiaoku-171",
  "icontubiaoku-19": "iconyonghufenxi",
  "icontubiaoku-20": "iconshuju",
  "icontubiaoku-22": "icontubiaoku-221",
  "icontubiaoku-23": "iconshujudaping",
  "icontubiaoku-7": "icontubiaoku-71",
  "icontubiaoku-21": "icontubiaoku-211",
  "icontubiaoku-24": "icontubiaoku-241",
  "icontubiaoku-18": "icontubiaoku-181",
  "icontubiaoku-13": "icontubiaoku-131",
  "icontubiaoku-14": "icontubiaoku-141",
  "icontubiaoku-25": "icontubiaoku-251"
  }
  if (iconList.includes(icon)) {
    return mapping[icon]
  }
  return icon
}
